/* AI image badge: opens the explanation dialog. Markup in snippets/heimat-ai-label*.liquid. */
(() => {
  const TRIGGER = '[data-ai-label-open]';
  const CLOSE = '[data-ai-label-close]';
  const DIALOG_ID = 'HeimatAiLabelDialog';
  let opener = null;

  const getDialog = () => document.getElementById(DIALOG_ID);

  const open = (trigger) => {
    const dialog = getDialog();
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    opener = trigger;
    dialog.showModal();
  };

  // Capture phase: the badge sits inside links, sliders and the product zoom
  // opener. The click must not reach them.
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const trigger = target.closest(TRIGGER);
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        open(trigger);
        return;
      }

      const dialog = getDialog();
      if (!dialog || !dialog.open) return;
      // A click on the dialog element itself is a click on the backdrop.
      if (target === dialog || target.closest(CLOSE)) dialog.close();
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const target = event.target instanceof Element ? event.target : null;
      const trigger = target && target.closest(TRIGGER);
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
    },
    true
  );

  document.addEventListener(
    'close',
    (event) => {
      if (!(event.target instanceof Element) || event.target.id !== DIALOG_ID) return;
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
      opener = null;
    },
    true
  );
})();
